import Axios from 'axios'
import { Dispatch } from 'redux'

import { ActionResponse, Id } from 'util/types/index'
import { PartnerProduct, PartnerProductTypes, ProductSection, ProductSectionData } from '../types'
import { clearAlert, createAlert, handleError } from 'util/modules/Alert/redux/actions'
import { getPartnerProduct } from './product'

export function createSection (partnerId: Id, pProdId: Id, data: ProductSectionData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerProduct>> => {
    return Axios
      .post(`/partner/${partnerId}/product/${pProdId}/section`, data)
      .then(res => res.data)
      .then(async res => {
        if (res?.status === 'success' && res?.data) {
          await getPartnerProduct(partnerId, pProdId)(dispatch)
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao adicionar a sessão')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function updateSection (partnerId: Id, pProdId: Id, id: Id, data: ProductSectionData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerProduct>> => {
    return Axios
      .put(`/partner/${partnerId}/product/${pProdId}/section/${id}`, data)
      .then(res => res.data)
      .then(async res => {
        if (res?.status === 'success' && res?.data) {
          await getPartnerProduct(partnerId, pProdId)(dispatch)
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao atualizar a sessão')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function deleteSection (partnerId: Id, pProdId: Id, id: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerProduct>> => {
    return Axios
      .delete(`/partner/${partnerId}/product/${pProdId}/section/${id}`)
      .then(res => res.data)
      .then(async res => {
        if (res?.status === 'success' && res?.data) {
          await getPartnerProduct(partnerId, pProdId)(dispatch)
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao remover a sessão')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}
